module.exports = __webpack_public_path__ + "img/logo.0e08f83d.png";